module.exports = __webpack_public_path__ + "img/inbox-mail-notification.e88c037c.gif";